import React from 'react';
import PageFolderLink from '@frontastic/catwalk/js/app/pageFolderLink';
import { CategoryProps } from '../desktopMenu/secondaryMenuLevel/SecondaryMenuLevelProps.types';

interface CategoryLinkProps {
  category: CategoryProps;
  linkColor?: string;
  handleReferenceClick?: (e: React.MouseEvent, isTop: boolean, hasChildren: boolean) => void;
  isTop?: boolean;
  hasChildren?: boolean;
  forceSpan?: boolean;
}

const MenuLink: React.FC<CategoryLinkProps> = ({
  category,
  linkColor,
  handleReferenceClick,
  isTop = false,
  hasChildren = false,
  forceSpan = false,
}) => {
  const handleClick = (e: React.MouseEvent) => {
    if (handleReferenceClick) {
      handleReferenceClick(e, isTop, hasChildren);
    }
  };

  const pageFolder = category?.reference ? category?.reference?.pageFolder || category?.reference : category;

  return (category?.children?.length && forceSpan) ? (
    <span onClick={handleClick} style={{ color: linkColor }} aria-label={category?.name}>
      {category?.name}
    </span>
  ) : (
    <PageFolderLink
      key={pageFolder?.pageFolderId}
      pageFolder={pageFolder}
      style={{ color: linkColor }}
      itemProp="url"
      onClick={handleClick}
      aria-label={pageFolder?.name}
    >
      <span itemProp="name">{category?.name}</span>
    </PageFolderLink>
  );
};

export default MenuLink;
